import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'keyValueNoSort',
	standalone: false
})
export class KeyValueNoSortPipe implements PipeTransform {

	transform(object: Record<string, string | number> | Map<string, string | number>) {
		const array:{key:string, value:string | number}[]=[];
		if(object instanceof Map){
			for(const [key,value] of object)
				array.push({key,value});
		}else{
			for(const key in object)
				array.push({key, value: object[key]});
		}
		return array;
	}
}
